// extracted by mini-css-extract-plugin
export const card = "styles-module--card--2pFSh";
export const iconGroup = "styles-module--iconGroup--JFPXu";
export const logo = "styles-module--logo--PTFBd";
export const linkLogo = "styles-module--linkLogo---guBD";
export const content = "styles-module--content--nAd99";
export const activatingCashback = "styles-module--activatingCashback--rMFZc";